import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareDownloadingEnabledMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  downloadingEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareDownloadingEnabledMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, downloadingEnabled: boolean } | { __typename?: 'CollectionShare', id: string, downloadingEnabled: boolean } | null } | null };


export const UpdateShareDownloadingEnabled = /*#__PURE__*/ gql`
    mutation UpdateShareDownloadingEnabled($shareId: ID!, $downloadingEnabled: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {downloadingEnabled: $downloadingEnabled}}
  ) {
    share {
      id
      downloadingEnabled
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareDownloadingEnabledMutation, UpdateShareDownloadingEnabledMutationVariables>;

          

          export const useUpdateShareDownloadingEnabledMutation = (options?:MutationHookOptions<UpdateShareDownloadingEnabledMutation, UpdateShareDownloadingEnabledMutationVariables>) => useMutation(UpdateShareDownloadingEnabled, options);
          

          export type UpdateShareDownloadingEnabledMutationOptions = MutationHookOptions<UpdateShareDownloadingEnabledMutation, UpdateShareDownloadingEnabledMutationVariables>;

          

          export type UpdateShareDownloadingEnabledMutationResult = ReturnType<typeof useUpdateShareDownloadingEnabledMutation>[1];

          
